import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";

export default function PreserveReceivingFormState() {
  const { values, isSubmitting } = useFormikContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (isSubmitting || !params.has("generateReportId")) {
      return;
    }

    let changed = false;

    if (values.projectId) {
      if (params.get("projectId") !== values.projectId) {
        params.set("projectId", values.projectId);
        changed = true;
      }
    } else {
      if (params.has("projectId")) {
        params.delete("projectId");
        changed = true;
      }
    }

    if (values.startDate) {
      const dateStr = moment(values.startDate).format("YYYY-MM-DD");
      if (params.get("startDate") !== dateStr) {
        params.set("startDate", dateStr);
        changed = true;
      }
    } else {
      if (params.has("startDate")) {
        params.delete("startDate");
        changed = true;
      }
    }

    if (values.endDate) {
      const dateStr = moment(values.endDate).format("YYYY-MM-DD");
      if (params.get("endDate") !== dateStr) {
        params.set("endDate", dateStr);
        changed = true;
      }
    } else {
      if (params.has("endDate")) {
        params.delete("endDate");
        changed = true;
      }
    }

    if (changed) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [values.projectId, values.startDate, values.endDate, isSubmitting, navigate, location.search]);

  return null;
}
